import React from 'react';

const Required: React.FC = () => {
  return <span className="small text-primary ms-2">※必須</span>;
};

export default Required;
